import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/fp/isEmpty';
const MultiselectToggleSelection = (props) => {
    const { options, selectedItemIds, showSelectedItemIcon, showUnselectedItemIcons, multiline, hasInputAddon, hasFilter, onRemoveItem, children, } = props;
    if (!options || isEmpty(options)) {
        return null;
    }
    const isItemSelected = (item) => {
        return selectedItemIds.indexOf(item.id) !== -1;
    };
    const renderSelectionItem = (item, index) => {
        if (showSelectedItemIcon) {
            const inactiveClassNames = classNames('margin-right-5', !isItemSelected(item) && 'inactiveIcon');
            return (_jsx("span", Object.assign({ className: inactiveClassNames }, { children: item.icon }), item.id));
        }
        return (_jsxs("span", Object.assign({ className: 'selected-option' }, { children: [_jsxs("span", Object.assign({ className: 'selected-label' }, { children: [item.icon && _jsx("span", Object.assign({ className: 'margin-right-5' }, { children: item.icon })), item.label] })), _jsx("span", Object.assign({ className: 'removeIcon', onClick: event => {
                        onRemoveItem(event, item.id);
                    } }, { children: _jsx("span", { className: 'rioglyph rioglyph-remove' }) }))] }), index));
    };
    const optionListClassNames = classNames(!showSelectedItemIcon && !showUnselectedItemIcons && 'selected-option-list', multiline && 'flex-wrap', hasInputAddon && 'margin-left-0', hasFilter && 'padding-left-1');
    return (_jsxs("span", Object.assign({ className: optionListClassNames }, { children: [options
                .filter(option => (showUnselectedItemIcons ? !option.header : isItemSelected(option)))
                .map((option, index) => renderSelectionItem(option, index)), children] })));
};
export default MultiselectToggleSelection;
